'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.categories.edit', [])
  .controller('CategoriesEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/categories/edit/index.js